<div>
  <button
    mat-stroked-button
    type="button"
    class="pull-right"
    [disabled]="_disabled"
    [id]="id"
    (click)="click()">
    {{_label}}
  </button>
</div>